import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';
import { saveDownloadedFile, SPREADSHEET_MIME_TYPE } from '../downloadFile';

interface TransitProps {
  transitId: string;
  houseConsignmentIndex: number;
  transitName: string;
}

export const useDownloadHouseConsignmentItems = () => {
  return useMutation({
    mutationFn: async ({ transitId, houseConsignmentIndex, transitName }: TransitProps) => {
      const result = await apiClient.transit.downloadHouseConsignmentItems.query({
        params: { transitId, houseConsignmentIndex: houseConsignmentIndex.toString() },
      });
      if (result.status !== 200) throw result.body;

      saveDownloadedFile(result.body as Blob, result.headers, SPREADSHEET_MIME_TYPE, `${transitName}-houseConsignment-${houseConsignmentIndex}.xlsx`);
    },
    onSuccess: () => {
      toast.success('Successfully downloaded the list!');
    },
    onError: (error) => {
      showErrorToast(error, `Error downloading the house consignment items!`);
    },
  });
};
